import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import ContentSections from '../../../components/base/ContentSections';
import './CampaignCategoryDetail.scss';
import { APIStatus, LanguageConfig } from '../../../config/CustomEnums';
import Loading from '../../../components/base/Loading';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';

const CampaignCategoryDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const { category, createStatus } = useSelector((state) => ({
    category: state.createCampaignCategory.category,
    createStatus: state.createCampaignCategory.createStatus,
  }));
  const order = `(${category?.order})`;
  const tabs = [
    {
      name: 'Detail',
      content: (
        <ContentSections
          sections={[
            createStatus === APIStatus.calling ? (
              <Loading />
            ) : (
              <>
                <label className="create-section-title">CONTENT</label>
                <PerfectScrollbar>
                  <table className="campaign-category-detail-table">
                    <thead>
                      <th></th>
                      <th>English</th>
                      <th>繁體</th>
                      <th>简体</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Name(Order)</td>
                        <td>
                          {category.name}
                          {order}
                        </td>
                        <td>
                          {category.translations.filter(
                            (t) =>
                              t.language === LanguageConfig.traditionalChinese,
                          )[0]?.name || '-'}
                          {order}
                        </td>
                        <td>
                          {category.translations.filter(
                            (t) =>
                              t.language === LanguageConfig.simplifiedChinese,
                          )[0]?.name || '-'}
                          {order}
                        </td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>
                          {category.isForcedInactive ? 'Inactive' : 'Active'}
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </PerfectScrollbar>
              </>
            ),
          ]}
          hidePreview
          // sectionStyle="detail-info-section-item"
        />
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => {
        // dispatch({ type: 'customerList/clearData' });
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeCampaignCategory}
    />,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    const categoryID = params.id;
    if (categoryID) {
      dispatch(
        createAction('createCampaignCategory/getCategory')({ id: categoryID }),
      );
    }
    return () => {
      dispatch({ type: 'createCampaignCategory/reset' });
    };
  }, []);

  return (
    <div className="campaign-category-detail">
      <CustomListComponent
        caution={{
          detail: '',
          title: category.name,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={category.name} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
};

export default CampaignCategoryDetail;
